/* eslint-disable eslint-comments/no-restricted-disable */

import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { savedSearchTabEntryPoint } from '@jira/assets-app__data-manager-object-class-view/src/savedSearchTabEntryPoint.entrypoint.tsx';
import { tagsTabEntryPoint } from '@jira/assets-app__data-manager-object-class-view/src/tagsTabEntryPoint.entrypoint.tsx';
import { objectsTabEntryPoint } from '@jira/assets-app__data-manager-object-class-view/src/objectsTabEntryPoint.entrypoint.tsx';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { JSResourceForInteraction } from '@atlassian/react-async';

type AssetsDataManagerObjectClassViewEntryPointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const assetsDataManagerObjectClassViewEntryPoint: EntryPoint<
	AssetsDataManagerObjectClassViewEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<AssetsDataManagerObjectClassViewEntryPointComponent>(
		/* webpackChunkName: "async-assets-data-manager-object-class-view", jiraSpaEntry: "async-assets-data-manager-object-class-view" */ './AssetsDataManagerObjectClassViewSpa.tsx',
	),
	getPreloadProps: ({ context: { query } }: EntryPointRouteParams) => {
		const { tab } = query;
		if (tab === 'saved-search') {
			return {
				entryPoints: {
					savedSearchTabEntryPoint: {
						entryPoint: savedSearchTabEntryPoint,
					},
				},
			};
		}
		if (tab === 'tags') {
			return {
				entryPoints: {
					tagsTabEntryPoint: {
						entryPoint: tagsTabEntryPoint,
					},
				},
			};
		}
		// default to objects tab
		return {
			entryPoints: {
				objectsTabEntryPoint: {
					entryPoint: objectsTabEntryPoint,
				},
			},
		};
	},
});
